<app-stepper
        [headerTitle]="'Enviar email'"
        [headerLength]="mapSteps.length"
        [headerPositionActive]="positionActive"
        [mapTitle]="'CAMBIO DE CONTRASEÑA'"
        [$mapSteps]="$mapStepChange"
>
</app-stepper>
